/** @jsx jsx */
import { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Button, Container, Grid, Heading, jsx, Text } from 'theme-ui'
import ListingCardSpecs from '~/components/Listing/Card/Specs'
import Modal from '~/components/Generic/Modal'

const FeaturedGiftsSectionItem = ({ gift }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const { longDescription, mainImage, name, shortDescription, subtitle } = gift

  return (
    <Box>
      {mainImage && (
        <GatsbyImage
          image={mainImage.gatsbyImageData}
          alt={mainImage.description}
        />
      )}
      <Box mt={2} px={1}>
        <Heading as="h3" variant="title4" mb="4px">
          {name}
        </Heading>
        {subtitle && (
          <Text as="h4" variant="subtitle2" mb={2}>
            {subtitle}
          </Text>
        )}
        {shortDescription && (
          <Text as="p" variant="body2" m={0}>
            {shortDescription}
          </Text>
        )}
        <Button onClick={() => setIsExpanded(true)} variant="reset" mt={1}>
          <Text
            as="span"
            variant="body2"
            sx={{
              color: 'brandPrimary',
              textDecoration: 'underline',
            }}
          >
            View details
          </Text>
        </Button>
      </Box>
      {isExpanded && (
        <Modal onClose={() => setIsExpanded(false)} maxWidth="540px">
          <ListingCardSpecs
            description={longDescription}
            descriptionVariant="included"
            image={mainImage}
            subtitle={subtitle}
            title={name}
          />
        </Modal>
      )}
    </Box>
  )
}

const FeaturedGiftsSection = ({ title, gifts }) => {
  return (
    <Box bg="backgroundLight" pt={[7, 9, null, 13]} pb={[8, 10, null, 14]}>
      <Container>
        <Heading
          as="h2"
          variant="title2"
          mb={[4, 5, 6]}
          sx={{ textAlign: 'center' }}
        >
          {title}
        </Heading>
        <Grid columns={[1, 3]}>
          {gifts.map((gift, index) => (
            <FeaturedGiftsSectionItem
              key={`featured-gift-${index}`}
              gift={gift}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default FeaturedGiftsSection
